// 시즌 액션팩 — 구체 시험일·마감 시각 없음. 공식 공고 확인 전제.
// resourceIds → officialResources.js / 인라인 links·paths

export const actionPackMeta = {
  title: '2026 시즌 액션팩',
  lede:
    '시즌이 올 때마다 아래 블록을 순서대로 확인하세요. 정확한 일자·마감은 각 공식 링크의 해당 연도 공고로 확정합니다.',
  note: '결제 확인 후 운영 메일로 이 팩 열람을 안내합니다. 사이트 공개 미리보기는 참고용입니다.',
  updatedAt: '2026-07',
};

export const actionPackBlocks = [
  {
    id: 'kickoff',
    season: '연초·계획',
    title: '한 해 루트·시즌 맵 잡기',
    focus: 'EJU / 일반 / 국비 중 주력과 병행을 적고, 캘린더 블록과 맞춥니다.',
    checks: [
      '주력 전형 하나 + 병행 여부를 메모',
      '관심 대학 3곳 후보와 요강 PDF·공식 페이지 북마크',
      '무료 시즌 일정·요강 체크리스트로 기본 틀 확인',
    ],
    resourceIds: ['jasso-eju', 'studyinjapan-home'],
    paths: [
      { label: '시즌 일정', path: '/calendar' },
      { label: '요강 체크', path: '/checklist' },
      { label: '루트 파인더', path: '/finder' },
    ],
  },
  {
    id: 'eju-june',
    season: '상반기',
    title: 'EJU 제1회 창',
    focus: '통상 6월 회차. 출원·시험·성적 일정은 JASSO 공고만 신뢰합니다.',
    checks: [
      '해당 연도 EJU 출원·시험 공고 열기',
      '지망교 요강의 EJU 지정 회차와 맞는지 대조',
      '2026 기초학력 시라버스 개정 적용 여부 확인',
      '영어 외부시험 유효기간이 출원까지 남는지 점검',
    ],
    resourceIds: [
      'jasso-eju',
      'jasso-eju-syllabus-revision',
      'jasso-eju-syllabus-2026',
    ],
    paths: [{ label: 'EJU 2026 시라버스 가이드', path: '/guides/eju-2026-syllabus' }],
  },
  {
    id: 'mext-window',
    season: '봄–여름',
    title: '국비(MEXT) 공고 창',
    focus: '한국은 주한일본대사관 연도 공고가 기준. 사비 일정과 겹침을 비워 둡니다.',
    checks: [
      '대사관 국비 안내·최신 공고 목록 열기',
      '대사관 추천 vs 대학 추천 중 경로 정하기',
      '사비 EJU/일반 병행 일정을 캘린더에 표시',
    ],
    resourceIds: ['studyinjapan-mext-undergrad'],
    links: [
      {
        label: '주한일본대사관 국비',
        url: 'https://www.kr.emb-japan.go.jp/itpr_ko/study_government.html',
      },
    ],
    paths: [{ label: 'MEXT 학부 가이드', path: '/guides/mext-scholarship' }],
  },
  {
    id: 'eju-nov',
    season: '하반기',
    title: 'EJU 제2회 창',
    focus: '통상 11월 회차. 이듬해 출원에 쓰는 경우가 많습니다.',
    checks: [
      '제2회 출원·시험 공식 공고 확인',
      '봄·가을 입학 요강의 인정 회차와 매칭',
      '서류·영어 직송 마감을 요강에서 역산',
    ],
    resourceIds: ['jasso-eju'],
    paths: [{ label: '요강 체크', path: '/checklist' }],
  },
  {
    id: 'kyotsu',
    season: '연말–연초',
    title: '공통테스트·일반선발 창',
    focus: '일반선발 지망만. 실시일·출원은 DNC·대학 요강.',
    checks: [
      'DNC에서 해당 연도 시험·출원 일정 확인',
      '대학 요강의 공통테스트 이용 과목 표 작성',
      '본고사 일정과 겹침 없는지 확인',
    ],
    links: [
      { label: 'DNC 공통테스트', url: 'https://www.dnc.ac.jp/kyotsu/' },
      { label: 'Web 출원 안내', url: 'https://www.dnc.ac.jp/kyotsu/web_syutugan.html' },
    ],
    paths: [{ label: '비교표', path: '/compare' }],
  },
  {
    id: 'apply-peak',
    season: '가을–겨울 / 봄',
    title: '대학 출원·면접 성수기',
    focus: '학부·전형마다 다름. 요강 캘린더가 최종입니다.',
    checks: [
      '관심 대학 3곳 요강으로 접수·필착·시험일 표 만들기',
      '해외출원 모드 체크리스트 점검',
      '검정료·서류·영어 직송 마감 역산',
    ],
    paths: [
      { label: '요강 체크', path: '/checklist' },
      { label: '루트 파인더', path: '/finder' },
      { label: '공식 자료', path: '/resources' },
    ],
  },
];
